<template>
	<div class="timer">
		<div>
			<span class="timer-val month" v-if="timeUntil.month">{{ timeUntil.month }}m </span>
			<span class="timer-val week" v-if="timeUntil.week">{{ timeUntil.week }}w </span>
			<span class="timer-val day" v-if="timeUntil.day">{{ timeUntil.day }}d </span>
			<span class="timer-val hour" v-if="timeUntil.hour">{{ timeUntil.hour }}h</span>
			<span class="timer-val minute" v-if="timeUntil.minute">{{ timeUntil.minute }}m</span>
			<span class="timer-val second" v-if="timeUntil.second >= 0">{{ timeUntil.second }}s</span>
			<span v-else>0h 0m 0s</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'timer',
	data () {
		return {
			interval: null,
			timeUntil: {},
			startTime: null
		}
	},

	props: {
		timesince: Number,
		countdown: {
			type: Boolean,
			default: true
		},
		info: String,
		shouldtick: {
			type: Boolean,
			default: true
		},
		iscalculated: {
			type: Boolean,
			default: false
		}
	},

	mounted () {
		this.tick();
		this.interval = setInterval(this.tick, 1 * 1000);
	},

	watch: {
		timesince: function(newval) {
			this.startTime = null;
		}
	},

	methods: {
		tick: function () {
			this.calculateTimeRemaining()
		},

		calculateTimeRemaining: function () {
			this.timeUntil = {}

			if (this.timesince === 0) {
				return
			}

			var dateObj = new Date();
			var currentTimestamp = dateObj.getTime();
			var finishTimestamp = (this.timesince * 1000);
			var timeRemaining = 0;

			if (this.iscalculated === false) {
				if (this.shouldtick == true) {
					if (this.countdown == true) {
						timeRemaining = Math.abs(currentTimestamp - finishTimestamp);
					} else {
						timeRemaining = Math.abs(finishTimestamp - currentTimestamp);
					}
				} else {
					timeRemaining = finishTimestamp;
				}
			} else {
				timeRemaining = finishTimestamp;
				if (this.shouldtick === true) {
					if (!this.startTime) this.startTime = finishTimestamp;
					else timeRemaining = (this.startTime += 1000);
				}
			}

			if (timeRemaining === 0) {
				return
			}

			var s = {
				month: 		2592000000,
				week: 		604800000,
				day: 		86400000,
				hour: 		3600000,
				minute: 	60000,
				second: 	1000
			}

			var self = this
			Object.keys(s).forEach(function (key) {
				self.timeUntil[key] = Math.floor(timeRemaining / s[key])
				timeRemaining -= (self.timeUntil[key] * s[key])
			})
		}
	},

	filters: {
		pad: function (val) {
			if (val < 10) {
				return '0' + val
			}

			return val
		}
	}
}
</script>

<style lang="scss" scoped>
.timer {
	div {
		display: inline-block;
		margin: 0 auto;

		span {
			display: inline-block;
			/*float: left;*/
		}
	}
}
</style>



// WEBPACK FOOTER //
// Timer.vue?4f910648